<template>
    <div class="custom-list-wrapper">
        <div v-for="(panel, idx) in panels" :key="idx" class="custom-list-panel">
            <CustomFormItem
                v-for="(item, itemIdx) in panel"
                :key="itemIdx"
                :value="values[idx][item.props.name]"
                :widget="item"
                :labelProps="commChildLabelProps"
                :verifyInfo="(verifyInfo.items && verifyInfo.items[idx] && verifyInfo.items[idx][item.props.name]) || {}"
                :rules="(rules.item && rules.item[item.props.name]) || []"
                :validation="validation"
                @change="changeHandler(item, idx, $event)"
                @verify="verifyHandler(item, idx, $event)"
            />
            <span class="op">
                <i class="transfer" @mousedown="tranferItem(idx, $event)" />
            </span>
            <DeleteIcon class="custom-list-panel-delete" @iconClick="deletePanel(idx)" />
        </div>
        <div class="custom-list-add">
            <el-select v-if="isShowTplSelect" value="" placeholder="请选择模板" @change="selectPanelTpl">
                <el-option v-for="slotName in slotNames" :key="slotName" :label="slotName" :value="slotName" />
            </el-select>
            <el-button v-show="isShowAdd" @click="addPanel">添加</el-button>
        </div>
    </div>
</template>

<script>
import DeleteIcon from "@/views/zhiji/bComponents/icons/DeleteIcon.vue";

export default {
    name: "List",
    components: {
        CustomFormItem: () => import("./FormItem.vue"),
        DeleteIcon
    },
    props: ["value", "widget", "verifyInfo", "rules", "validation"],
    data() {
        return {
            isShowTplSelect: false
        };
    },
    computed: {
        values() {
            let values = this.value || [];
            values = Array.isArray(values) ? values : [values];
            return values.filter(v => !!v.$tempName);
        },
        commChildLabelProps() {
            const { props } = this.widget;
            const ret = {};
            if (props.subItemLabelPosition) {
                ret.labelPosition = props.subItemLabelPosition;
            }
            if (props.subItemLabelWidth) {
                ret.labelWidth = props.subItemLabelWidth;
            }
            return ret;
        },
        panels() {
            const panelValues = this.values;
            return panelValues.map(panel => {
                const panelTpl = this.widget.slots[panel.$tempName];
                return panelTpl;
            });
        },
        slotNames() {
            const slots = this.widget.slots || {};
            return Object.keys(slots);
        },
        maxCount() {
            const { props } = this.widget;
            return props.maxCount || 100;
        },
        isShowAdd() {
            return this.values.length < this.maxCount;
        }
    },
    created() {
        const { minCount } = this.widget.props;
        const curCount = (this.value || []).length;
        if (minCount && this.slotNames.length === 1 && curCount < minCount) {
            for (let i = curCount; i < minCount; ++i) {
                setTimeout(() => this.addPanel(), 15);
            }
        }
    },
    methods: {
        changeHandler(item, panelIdx, newItemData) {
            const newValues = this.values.slice();
            const panelValue = newValues[panelIdx];
            newValues.splice(panelIdx, 1, { ...panelValue, [item.props.name]: newItemData });
            this.$emit("change", newValues);
        },
        deletePanel(panelIdx) {
            const newValues = this.values.slice();
            newValues.splice(panelIdx, 1);
            this.$emit("change", newValues);
            this.deleteVerify(panelIdx);
        },
        addPanel() {
            if (this.slotNames.length === 1) {
                this.selectPanelTpl(this.slotNames[0]);
                return;
            }
            this.isShowTplSelect = true;
        },
        selectPanelTpl(selectedSlot) {
            const newValues = this.values.slice();
            newValues.push({
                $tempName: selectedSlot
            });
            this.$emit("change", newValues);
            this.isShowTplSelect = false;
        },
        tranferItem(panelIdx, event) {
            this.tools.dragStart(event, "custom-list-panel", "v", newIdx => {
                const newValues = this.values.slice();
                const item = newValues[panelIdx];
                newValues.splice(panelIdx, 1);
                newValues.splice(newIdx, 0, item);
                this.$emit("change", newValues);
                this.transforVerify(panelIdx, newIdx);
            });
        },
        verifyHandler(item, index, info) {
            const newVerifyInfo = { ...this.verifyInfo };
            newVerifyInfo.items = [...(newVerifyInfo.items || [])];
            newVerifyInfo.items[index] = { ...(newVerifyInfo.items[index] || {}) };
            newVerifyInfo.items[index][item.props.name] = info;
            this.$emit("verify", newVerifyInfo);
        },
        deleteVerify(index) {
            const newVerifyInfo = { ...this.verifyInfo };
            newVerifyInfo.items = [...(newVerifyInfo.items || [])];
            newVerifyInfo.items.splice(index, 1);
            this.$emit("verify", newVerifyInfo);
        },
        transforVerify(fIndex, tIndex) {
            const newVerifyInfo = { ...this.verifyInfo };
            newVerifyInfo.items = [...(newVerifyInfo.items || [])];
            const item = newVerifyInfo.items.splice(fIndex, 1);
            newVerifyInfo.items.splice(tIndex, 0, item);
            this.$emit("verify", newVerifyInfo);
        }
    }
};
</script>

<style scoped lang="less">
.custom-list-wrapper {
    position: relative;
    padding-top: 1px;

    .custom-list-panel {
        position: relative;
        padding: 0px 61px 0px 0;
    }

    .custom-list-panel-delete {
        position: absolute;
        right: -4px;
        top: 4px;
    }

    .op {
        position: absolute;
        right: 27px;
        top: 0;
        margin-bottom: 8px;
        cursor: pointer;
        display: inline-flex;
        width: 26px;
        height: 26px;
        border-radius: 50%;
        align-items: center;
        justify-content: center;
        box-shadow: 0px 2px 6px rgba(46, 98, 151, 0.2);
        background: #fff;
    }

    .transfer {
        position: relative;
        display: inline-block;
        width: 16px;
        height: 18px;
        margin: 0 5px 0 5px;
        vertical-align: middle;
        background: url("@{zhijiStaticImagePath}class-spr2.png");
    }

    .transfer {
        width: 13px;
        background-position: -113px 0;

        &:hover {
            background-position: -113px -22px;
        }
    }
}
</style>
